export default __webpack_public_path__ + "assets/models/8be6d4abb4e670ac5a8a1473110b16ce.glb";